/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { dataActions } from "../../../../shared/store/data-Slice";
import LoginComponent from "../../../../components/common/auth/Login";

const Login = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(dataActions.setLoginOpen(true))
    }, [])

    return (
        <LoginComponent type="admin" />
    );
};

export default Login;